import { seoHead } from "@/config/seoHead";
import { buildTitle } from "@/config/seoTitles";
import { SITE_URL } from "@/config/urlHierarchy";
import { compactMetaByPath } from "./index";
import type { CompactPage } from "./types";

/**
 * head() för en compact-sida: titel och beskrivning ur index.ts samt
 * FAQPage-schema ur den laddade sidan, så att allt finns i serverns HTML.
 */
export function compactHead(page: CompactPage | null | undefined, path: string) {
  const meta = compactMetaByPath(path);
  if (!meta) return { ...seoHead(path), scripts: [] };
  const base = seoHead(path, { title: buildTitle(meta.title, "page"), description: meta.description });
  if (!page?.faq.length) return { ...base, scripts: [] };
  return {
    ...base,
    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "FAQPage",
          url: `${SITE_URL}${path}`,
          mainEntity: page.faq.map((f) => ({
            "@type": "Question",
            name: f.question,
            acceptedAnswer: { "@type": "Answer", text: f.answer },
          })),
        }),
      },
    ],
  };
}
